import img from "../../assets/images/john.webp";
import icon from "../../assets/images/serviceicon3.svg";
import { motion } from "motion/react";

type StoryType = {
  icon: string;
  name: string;
  text: string;
};

const stories: StoryType[] = [
  {
    icon: icon,
    name: "Our Mission",
    text: "To provide strategic, results-driven financial solutions that empower organizations to navigate complex challenges, optimize resources, and achieve long-term success.",
  },
  {
    icon: icon,
    name: "Our Vision",
    text: "To be the trusted partner in financial leadership, transforming businesses within the healthcare and medical device industries by driving sustainable growth, operational efficiency, and innovation.",
  },
];

const Story = () => {
  return (
    <div className="max-w-screen-2xl mx-auto px-5 lg:px-20 pb-10 pt-10 lg:pt-0 lg:pb-28 xl:pt-28 overflow-hidden">
      <div className="lg:flex justify-between">
        <div className="lg:w-[45%] mb-10 lg:mb-0">
          <div className="group bg-primary size-full flex items-end justify-center rounded-[60px] relative px-10 pt-10 bg-cover overflow-hidden">
            <motion.img
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              whileHover={{ scale: 1.2 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              src={img}
              className="relative z-10 object-contain"
            />
            {/* <div className="w-full h-[30%] absolute bottom-0 bg-gradient-to-t from-primary to-transparent rounded-b-[60px]"></div> */}
            <div className="size-[350px] lg:size-[700px] bg-white p-20 rounded-full absolute top-0 bg-opacity-[0.04]">
              <div className="size-full bg-white p-20 rounded-full bg-opacity-5">
                <div className="size-full bg-white rounded-full bg-opacity-5"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[50%] flex flex-col justify-end">
          <div className="relative mb-9 lg:mt-9 xl:mt-0 ml-5 lg:ml-0">
            <motion.h3
              initial={{ x: -50, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="poppins-regular text-primary z-20 relative"
            >
              OUR STORY
            </motion.h3>
            <div className="size-16 bg-[#E7E9FF] rounded-full absolute -top-5 -left-5"></div>
          </div>
          <motion.h2
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="text-4xl sm:text-5xl montserrat-regular text-secondary mb-9"
          >
            A <span className="montserrat-semibold">Journey</span> of{" "}
            <span className="montserrat-semibold">Vision</span> and{" "}
            <span className="montserrat-semibold">Education</span>
          </motion.h2>
          <div className="flex flex-col lg:flex-row justify-between gap-4">
            {stories.map((item, index) => (
              <div className="" key={index}>
                <motion.img
                  initial={{ x: -100, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.3, delay: index + 1 * 0.3 }}
                  viewport={{ once: true }}
                  src={item.icon}
                  className="mb-3"
                />
                <motion.h3
                  initial={{ x: -100, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.3, delay: index + 1 * 0.6 }}
                  viewport={{ once: true }}
                  className="montserrat-semibold text-xl text-secondary mb-3"
                >
                  {item.name}
                </motion.h3>
                <motion.p
                  initial={{ x: -100, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.3, delay: index + 1 * 0.9 }}
                  viewport={{ once: true }}
                  className="text-secondary montserrat-regular"
                >
                  {item.text}
                </motion.p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Story;
